export const formatTutorDisplayName = (fullName?: string | null) => {
  const normalized = String(fullName || "")
    .trim()
    .replace(/\s+/g, " ");

  if (!normalized) return "Professeur";
  const parts = normalized.split(" ");
  const firstName = parts[0];

  if (parts.length < 2) return firstName;
  const familyInitial = parts[1]?.[0]?.toUpperCase();

  if (!familyInitial) return firstName;

  return `${firstName} ${familyInitial}.`;
};
